export type WebsiteSectionKey =
  | 'hero'
  | 'about'
  | 'toursEvents'
  | 'showcase'
  | 'gallery'
  | 'awards'
  | 'infoKit'
  | 'contact'
  // Management-only sections (siteType 'management' websites)
  | 'services'
  | 'artistRoster'
  | 'testimonials'
  | 'clients'
  | 'team';

export type SectionWidth = 'standard' | 'fluid';
export type ImagePosition = 'left' | 'right';
export type DesktopColumns = 3 | 4 | 6;

export interface WebsiteLayoutSection {
  key: WebsiteSectionKey;
  width: SectionWidth;
  imagePosition?: ImagePosition;
  desktopColumns?: DesktopColumns;
}

export interface WebsiteLayout {
  schemaVersion: number;
  revision: number;
  globalWidth: SectionWidth;
  shell: {
    navigation: { width: SectionWidth };
    footer: { width: SectionWidth };
    audioBar: { width: SectionWidth };
  };
  sections: WebsiteLayoutSection[];
}

export const WEBSITE_SECTION_LABELS: Record<WebsiteSectionKey, string> = {
  hero: 'Hero',
  about: 'About',
  toursEvents: 'Tours & Events',
  showcase: 'Showcase',
  gallery: 'Gallery',
  awards: 'Awards',
  infoKit: 'Info Kit',
  contact: 'Contact',
  // Management-only sections.
  services: 'Services',
  artistRoster: 'Our Artist Roster',
  testimonials: 'Testimonials',
  clients: 'Our Clients',
  team: 'Team',
};
